import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { UsersService } from '../services/users/users.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserGuideService implements OnDestroy {
  private usersService = inject(UsersService);
  private router = inject(Router);
  private readonly destroy = new Subject<void>();

  userName: string = '';

  constructor() {
    this.usersService.userSubject
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: user => {
          if (!user?.name) {
            this.userName = '';
          } else {
            const [firstName = '', lastName = ''] = user.name.split(' ', 2);
            this.userName = (firstName[0] ?? '') + (lastName[0] ?? '');
          }
        },
      });
  }

  anchorChapter(chapterId: string) {
    this.router.navigate([], { fragment: chapterId });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
}
